<div class="content-p">
  <div class="c-content" style="display: flex; margin-bottom: 10px">
    <div style="min-width: 80px; height: 80px; margin-right: 20px">
      <img
        src="../../../assets/img/logo.png"
        alt=""
        style="width: 80px; height: 80px"
      />
    </div>
    <div style="width: 78%">
      <div style="font-size: 16px; font-weight: 600">
        บริษัท กะเพรา เอ็กซ์เพรส จำกัด (สำนักงานใหญ่)
      </div>
      <div style="font-size: 12px">
        9 ซอยรามอินทรา 5 แยก 15 แขวง อนุสาวรีย์ เขต บางเขน
      </div>
      <div style="font-size: 12px">กรุงเทพมหานคร 10220</div>
      <div style="font-size: 12px">โทรศัพท์: 099-268-0711</div>
    </div>
    <div style="display: flex; width: 94%; place-content: flex-end">
      <div
        style="
          display: flex;
          flex-direction: column;
          align-items: flex-end;
          align-self: flex-end;
          position: absolute;
          right: 20px;
          gap: 4px;
        "
      >
        <div
          style="
            width: 50%;
            display: flex;
            justify-content: center;
            align-items: center;
          "
        ></div>
        <div style="display: flex">
          <div style="margin-right: 4px">เลขที่ / No.</div>
          <div style="width: 200px; border-bottom: 1px solid">
            {{ pData?.noRunning }}
          </div>
        </div>
        <div style="display: flex">
          <div style="margin-right: 4px">วันที่ / Date.</div>
          <div style="width: 200px; border-bottom: 1px solid">
            {{ pData?.createTime }}
          </div>
        </div>
        <div style="display: flex">
          <div style="margin-right: 4px">
            ออกแทนใบกำกับภาษีอย่างย่อเลขที่ / ABB No.
          </div>
          <div style="width: 200px; border-bottom: 1px solid">
            {{ pData?.orderNo }}
          </div>
        </div>
      </div>
    </div>
  </div>
  <div style="margin-left: 40px; display: flex; margin-top: 20px">
    <div style="width: 65%; display: flex">
      <div style="margin-right: 7px">
        สาขาที่ออกใบกำกับภาษี / Branch สาขาที่
      </div>
      <div>{{ pData?.branchCode }}</div>
    </div>
    <div style="display: flex; width: 100%; place-content: flex-end">
      <div style="margin-right: 10px">
        เลขประจำตัวผู้เสียภาษี / Tax ID: 0105565008840
      </div>
      <div
        style="
          padding: 8px 10px;
          margin-left: 6px;
          width: 110px;
          text-align: center;
          border: 2px solid;
          border-radius: 5px;
        "
      >
        ต้นฉบับ / Original
      </div>
    </div>
  </div>
  <div style="text-align: center; margin: 20px 0">
    <div style="font-size: 16px; font-weight: 600">
      ใบเสร็จรับเงิน / ใบกำกับภาษี
    </div>
    <div style="font-size: 16px; font-weight: 600">Receipt / Tax invoice</div>
  </div>
  <div style="margin-left: 40px; display: flex">
    <div style="width: 100%; display: flex; margin-bottom: 10px">
      <div style="margin-right: 7px">ชื่อผู้รับ / Customer:</div>
      <div>{{ pData?.recipientName }}</div>
    </div>
    <div style="display: flex; width: 100%; place-content: flex-end">
      <div style="margin-right: 7px">เลขประจำตัวผู้เสียภาษี / Tax ID:</div>
      <div style="width: 135px">{{ pData?.recipientTax }}</div>
    </div>
  </div>
  <div style="margin-left: 40px; display: flex; margin-bottom: 10px">
    <div style="width: 100%; display: flex">
      <div style="margin-right: 7px">ที่อยู่ / Address:</div>
      <div>{{ pData?.recipientAddress }}</div>
    </div>
  </div>
  <div style="margin-left: 40px; display: flex">
    <div
      style="
        width: 100%;
        display: flex;
        justify-content: center;
        border: 1px solid;
        padding: 5px 0;
        border-right: none;
        border-bottom: none;
      "
    >
      <div>รายการสินค้าหรือบริการ / Descriptions or Services</div>
    </div>
    <div
      style="
        display: flex;
        min-width: 165px;
        justify-content: center;
        border: 1px solid;
        padding: 5px 0;
        border-bottom: none;
      "
    >
      <div>จำนวนเงิน / Amount (บาท)</div>
    </div>
  </div>
  <div style="margin-left: 40px; display: flex">
    <div
      style="
        width: 100%;
        display: flex;
        justify-content: center;
        border: 1px solid;
        height: 150px;
        align-items: center;
        border-right: none;
      "
    >
      <div style="font-size: 16px">
        ค่าอาหารและเครื่องดื่ม ( Food & Beverages )
      </div>
    </div>
    <div
      style="
        display: flex;
        min-width: 165px;
        justify-content: end;
        border: 1px solid;
        height: 150px;
        align-items: center;
        border-bottom: none;
      "
    >
      <div style="margin-right: 7px">{{ pData?.total | number: "1.2-2" }}</div>
    </div>
  </div>
  <div style="margin-left: 40px; display: flex">
    <div
      style="
        width: 50%;
        display: flex;
        justify-content: center;
        border: 1px solid;
        align-items: center;
        padding: 5px 0;
        border-top: none;
      "
    >
      <div>{{ pData?.textResult }}</div>
    </div>
    <div style="width: 50%; display: flex; justify-content: flex-end">
      <div style="margin-right: 4px">ราคาก่อนภาษีมูลค่าเพิ่ม (Subtotal)</div>
      <div
        style="
          display: flex;
          min-width: 165px;
          justify-content: end;
          border: 1px solid;
          align-items: center;
          padding: 5px 0;
          border-bottom: none;
        "
      >
        <span style="margin-right: 7px">{{
          pData?.net | number: "1.2-2"
        }}</span>
      </div>
    </div>
  </div>
  <div style="margin-left: 40px; display: flex">
    <div
      style="
        width: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 5px 0;
      "
    >
      <div></div>
    </div>
    <div style="width: 50%; display: flex; justify-content: flex-end">
      <div style="margin-right: 4px">จำนวนภาษีมูลค่าเพิ่ม (VAT) 7%</div>
      <div
        style="
          display: flex;
          min-width: 165px;
          justify-content: end;
          border: 1px solid;
          align-items: center;
          padding: 5px 0;
          border-bottom: none;
        "
      >
        <span style="margin-right: 7px">{{
          pData?.vat | number: "1.2-2"
        }}</span>
      </div>
    </div>
  </div>
  <div style="margin-left: 40px; display: flex">
    <div style="width: 50%; display: flex; align-items: center">
      <div>
        ลงชื่อ
        .............................................................................
        ผู้รับเงิน
      </div>
    </div>
    <div style="width: 50%; display: flex; justify-content: flex-end">
      <div style="margin-right: 4px">จำนวนเงินรวมทั้งสิ้น (Total)</div>
      <div
        style="
          display: flex;
          min-width: 165px;
          justify-content: end;
          border: 1px solid;
          align-items: center;
          padding: 5px 0;
        "
      >
        <span style="margin-right: 7px">{{
          pData?.total | number: "1.2-2"
        }}</span>
      </div>
    </div>
  </div>
</div>
